import * as types from './constants';

// Get Creator Notes
export const getCreatorNotesRequest = data => (
  { type: types.GET_CREATOR_NOTES_REQUEST, payload: data }
);

export const getCreatorNotesDone = data => (
  { type: types.GET_CREATOR_NOTES_DONE, payload: data }
);

export const getCreatorNotesFailed = errors => (
  { type: types.GET_CREATOR_NOTES_FAILED, payload: errors }
);

// Load More Creator Notes
export const loadMoreCreatorNotesRequest = data => (
  { type: types.LOAD_MORE_CREATOR_NOTES_REQUEST, payload: data }
);

export const loadMoreCreatorNotesDone = data => (
  { type: types.LOAD_MORE_CREATOR_NOTES_DONE, payload: data }
);

export const loadMoreCreatorNotesFailed = errors => (
  { type: types.LOAD_MORE_CREATOR_NOTES_FAILED, payload: errors }
);

// Create Creator Note
export const createCreatorNoteRequest = data => (
  { type: types.CREATE_CREATOR_NOTE_REQUEST, payload: data }
);

export const createCreatorNoteDone = data => (
  { type: types.CREATE_CREATOR_NOTE_DONE, payload: data }
);

export const createCreatorNoteFailed = errors => (
  { type: types.CREATE_CREATOR_NOTE_FAILED, payload: errors }
);

// Update Creator Note
export const updateCreatorNoteRequest = data => (
  { type: types.UPDATE_CREATOR_NOTE_REQUEST, payload: data }
);

export const updateCreatorNoteDone = data => (
  { type: types.UPDATE_CREATOR_NOTE_DONE, payload: data }
);

export const updateCreatorNoteFailed = errors => (
  { type: types.UPDATE_CREATOR_NOTE_FAILED, payload: errors }
);

// Remove Creator Note
export const removeCreatorNoteRequest = data => (
  { type: types.REMOVE_CREATOR_NOTE_REQUEST, payload: data }
);

export const removeCreatorNoteDone = data => (
  { type: types.REMOVE_CREATOR_NOTE_DONE, payload: data }
);

export const removeCreatorNoteFailed = errors => (
  { type: types.REMOVE_CREATOR_NOTE_FAILED, payload: errors }
);

export const creatorNotesReset = () => (
  { type: types.CREATOR_NOTES_RESET }
);
